"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.I18nLabel = void 0;
var I18nLabel;
(function (I18nLabel) {
    I18nLabel["Close_Tab"] = "Close";
    I18nLabel["Close_Tabset"] = "Close tabset";
    I18nLabel["Move_Tab"] = "Move: ";
    I18nLabel["Move_Tabset"] = "Move tabset";
    I18nLabel["Maximize"] = "Maximize tabset";
    I18nLabel["Restore"] = "Restore tabset";
    I18nLabel["Float_Tab"] = "Show selected tab in floating window";
    I18nLabel["Overflow_Menu_Tooltip"] = "Hidden tabs";
    I18nLabel["Floating_Window_Message"] = "This panel is shown in a floating window";
    I18nLabel["Floating_Window_Show_Window"] = "Show window";
    I18nLabel["Floating_Window_Dock_Window"] = "Dock window";
    I18nLabel["Error_rendering_component"] = "Error rendering component";
})(I18nLabel = exports.I18nLabel || (exports.I18nLabel = {}));
//# sourceMappingURL=I18nLabel.js.map